import mock from 'api/mockFastApi';

import {
    mrm_simulations
} from './data';

mock.onPost('/simulators/mrm/simulation').reply(() => {
    return [200, mrm_simulations];
});
